import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { Dream } from './DreamCard';
interface DreamDetailProps {
  dream: Dream;
  onClose: () => void;
}
export function DreamDetail({
  dream,
  onClose
}: DreamDetailProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  useEffect(() => {
    modalRef.current?.focus();
  }, []);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-8" data-id="element-18">
      <div className="absolute inset-0 bg-[#2c241b]/60 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-19" />

      <div ref={modalRef} role="dialog" aria-modal="true" className="relative w-full max-w-3xl bg-[#fffef9] shadow-2xl transform transition-all max-h-[90vh] overflow-y-auto rounded-sm" tabIndex={-1} data-id="element-20">
        {/* Book spine effect on left */}
        <div className="absolute top-0 bottom-0 left-0 w-8 bg-gradient-to-r from-[#e5e0d0] to-transparent opacity-50 z-10 pointer-events-none" data-id="element-21" />

        {/* Close button */}
        <button onClick={onClose} className="absolute top-6 right-6 text-[#8b7355] hover:text-[#5c4033] transition-colors z-30 p-2" aria-label="Close journal entry" data-id="element-22">
          <X className="w-6 h-6" data-id="element-23" />
        </button>

        <div className="p-8 md:p-16 relative min-h-[500px]" data-id="element-24">
          {/* Lined paper background */}
          <div className="absolute inset-0 pointer-events-none" style={{
          backgroundImage: 'linear-gradient(#e5e0d0 1px, transparent 1px)',
          backgroundSize: '100% 2.5rem',
          marginTop: '4rem'
        }} data-id="element-25" />

          {/* Red margin */}
          <div className="absolute top-0 bottom-0 left-12 md:left-24 w-px bg-red-300/40 pointer-events-none" data-id="element-26" />

          <header className="relative mb-12 pl-8 md:pl-16" data-id="element-27">
            <div className="flex items-baseline justify-between border-b border-[#8b7355]/20 pb-4" data-id="element-28">
              <h2 className="font-serif text-3xl italic text-[#5c4033]" data-id="element-29">
                Journal Entry
              </h2>
              <time className="font-serif text-lg text-[#8b7355] italic" data-id="element-30">
                {dream.date}
              </time>
            </div>
          </header>

          <div className="relative pl-8 md:pl-16" data-id="element-31">
            <p className="font-handwriting text-2xl md:text-3xl leading-[2.5rem] text-[#5c4033] whitespace-pre-wrap" data-id="element-32">
              {dream.content}
            </p>
          </div>
        </div>
      </div>
    </div>;
}